import AbstractPiniaModel from './AbstractPiniaModel'
import { useMainCategoriesStore } from '../pinia/stores/mainCategories'
import { SubCategories } from 'Models'


export class MainCategories extends AbstractPiniaModel {
    //#region Instance Code
    constructor(mainCategory) {
        super(mainCategory)
    }

    id() {
        return this.source.id
    }
    slug() {
        return this.source.slug
    }
    name() {
        return this.source.name
    }
    description() {
        return this.source.beschreibung
    }
    image() {
        if (!this.source.picture) {
            return '/default-image.png' // or some default image path
        }
        return (
            (this.source.picture.substr(0, 1) === '/' ? '' : '/') +
            String(this.source.picture)
        )
    }
    position() {
        return this.source.position
    }
    subCategoryIds() {
        return this.source.sub_category_ids
    }
    subCategories() {
        return (this.subCategoryIds() || []).map((scID) =>
            SubCategories.createFromId(scID)
        )
    }
    //#endregion Instance Code

    //#region Static Methods
    static piniaStore() {
        return useMainCategoriesStore()
    }

    static create(mainCategorySource) {
        return new MainCategories(mainCategorySource)
    }
    static createFromId(id) {
        return this.findById(id)
    }

    static select(mainCategory) {
        this.selectById(mainCategory.id())
    }
    static selectById(id) {
        this.dispatch('selectCategoryById', id)
    }

    static setSelectedOnes(categories) {
        this.dispatch(
            'setSelectedCategories',
            categories.map((c) => c.getSource())
        )
    }
    static setAll(categories) {
        this.dispatch(
            'setAllMainCategories',
            categories.map((c) => c.getSource())
        )
    }

    static findById(id) {
        return this.create(this.piniaStore().findById(id))
    }
    static getSelected() {
        return this.create(this.piniaStore().selectedCategory)
    }
    static getSelectedOnes() {
        return this.piniaStore().selectedCategories.map((c) => this.create(c))
    }
    static getAll() {
        return this.piniaStore().allMainCategories.map((c) => this.create(c))
    }
    //#endregion Static Methods
}
